import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';

export const SET_IS_SAVING = 'isSaving/SET';

export const setIsSaving = createAction(SET_IS_SAVING);
